export default {
  cart: null,
};
